"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tapis Systems API
 * The Tapis Systems API provides for management of Tapis Systems including permissions, credentials and Scheduler Profiles.
 *
 * The version of the OpenAPI document: 1.0.0-rc1
 * Contact: cicsupport@tacc.utexas.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var SystemsApi = /** @class */ (function (_super) {
    __extends(SystemsApi, _super);
    function SystemsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Change owner of a system.
     * Change system owner
     */
    SystemsApi.prototype.changeSystemOwnerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.systemId === null || requestParameters.systemId === undefined) {
                            throw new runtime.RequiredError('systemId', 'Required parameter requestParameters.systemId was null or undefined when calling changeSystemOwner.');
                        }
                        if (requestParameters.userName === null || requestParameters.userName === undefined) {
                            throw new runtime.RequiredError('userName', 'Required parameter requestParameters.userName was null or undefined when calling changeSystemOwner.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/systems/{systemId}/changeOwner/{userName}".replace("{" + "systemId" + "}", encodeURIComponent(String(requestParameters.systemId))).replace("{" + "userName" + "}", encodeURIComponent(String(requestParameters.userName))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespChangeCountFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Change owner of a system.
     * Change system owner
     */
    SystemsApi.prototype.changeSystemOwner = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changeSystemOwnerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a system using a request body. System name must be unique within a tenant and can be composed of alphanumeric characters and the following special characters [-._~]. Name must begin with an alphabetic character and can be no more than 80 characters in length. Description is optional with a maximum length of 2048 characters.  By default any credentials provided for LINUX type systems are verified. Use query parameter skipCredentialCheck=true to bypass initial verification of credentials.  Note that certain attributes (such as tenant) are allowed but ignored so that the JSON result returned by a GET may be modified and used when making a POST request to create a system. The attributes that are allowed but ignored are    - tenant   - uuid   - deleted   - created   - updated
     * Create a system
     */
    SystemsApi.prototype.createSystemRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqCreateSystem === null || requestParameters.reqCreateSystem === undefined) {
                            throw new runtime.RequiredError('reqCreateSystem', 'Required parameter requestParameters.reqCreateSystem was null or undefined when calling createSystem.');
                        }
                        queryParameters = {};
                        if (requestParameters.skipCredentialCheck !== undefined) {
                            queryParameters['skipCredentialCheck'] = requestParameters.skipCredentialCheck;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/systems",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ReqCreateSystemToJSON(requestParameters.reqCreateSystem),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespResourceUrlFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a system using a request body. System name must be unique within a tenant and can be composed of alphanumeric characters and the following special characters [-._~]. Name must begin with an alphabetic character and can be no more than 80 characters in length. Description is optional with a maximum length of 2048 characters.  By default any credentials provided for LINUX type systems are verified. Use query parameter skipCredentialCheck=true to bypass initial verification of credentials.  Note that certain attributes (such as tenant) are allowed but ignored so that the JSON result returned by a GET may be modified and used when making a POST request to create a system. The attributes that are allowed but ignored are    - tenant   - uuid   - deleted   - created   - updated
     * Create a system
     */
    SystemsApi.prototype.createSystem = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createSystemRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Mark a system as deleted. System will not appear in queries unless explicitly requested.
     * Mark a system as deleted
     */
    SystemsApi.prototype.deleteSystemRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.systemId === null || requestParameters.systemId === undefined) {
                            throw new runtime.RequiredError('systemId', 'Required parameter requestParameters.systemId was null or undefined when calling deleteSystem.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/systems/{systemId}/delete".replace("{" + "systemId" + "}", encodeURIComponent(String(requestParameters.systemId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespChangeCountFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Mark a system as deleted. System will not appear in queries unless explicitly requested.
     * Mark a system as deleted
     */
    SystemsApi.prototype.deleteSystem = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteSystemRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Mark a system unavailable for use.
     * Mark a system unavailabe for use
     */
    SystemsApi.prototype.disableSystemRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.systemId === null || requestParameters.systemId === undefined) {
                            throw new runtime.RequiredError('systemId', 'Required parameter requestParameters.systemId was null or undefined when calling disableSystem.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/systems/{systemId}/disable".replace("{" + "systemId" + "}", encodeURIComponent(String(requestParameters.systemId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespChangeCountFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Mark a system unavailable for use.
     * Mark a system unavailabe for use
     */
    SystemsApi.prototype.disableSystem = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.disableSystemRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Mark a system available for use.
     * Mark a system availabe for use
     */
    SystemsApi.prototype.enableSystemRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.systemId === null || requestParameters.systemId === undefined) {
                            throw new runtime.RequiredError('systemId', 'Required parameter requestParameters.systemId was null or undefined when calling enableSystem.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/systems/{systemId}/enable".replace("{" + "systemId" + "}", encodeURIComponent(String(requestParameters.systemId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespChangeCountFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Mark a system available for use.
     * Mark a system availabe for use
     */
    SystemsApi.prototype.enableSystem = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.enableSystemRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve information for a system given the system name. Use query parameter returnCredentials=true to have effectiveUserId credentials included in the response. Use query parameter authnMethod=<method> to override default authn method.
     * Retrieve system details
     */
    SystemsApi.prototype.getSystemRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.systemId === null || requestParameters.systemId === undefined) {
                            throw new runtime.RequiredError('systemId', 'Required parameter requestParameters.systemId was null or undefined when calling getSystem.');
                        }
                        queryParameters = {};
                        if (requestParameters.returnCredentials !== undefined) {
                            queryParameters['returnCredentials'] = requestParameters.returnCredentials;
                        }
                        if (requestParameters.authnMethod !== undefined) {
                            queryParameters['authnMethod'] = requestParameters.authnMethod;
                        }
                        if (requestParameters.requireExecPerm !== undefined) {
                            queryParameters['requireExecPerm'] = requestParameters.requireExecPerm;
                        }
                        if (requestParameters.select !== undefined) {
                            queryParameters['select'] = requestParameters.select;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/systems/{systemId}".replace("{" + "systemId" + "}", encodeURIComponent(String(requestParameters.systemId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespSystemFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieve information for a system given the system name. Use query parameter returnCredentials=true to have effectiveUserId credentials included in the response. Use query parameter authnMethod=<method> to override default authn method.
     * Retrieve system details
     */
    SystemsApi.prototype.getSystem = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSystemRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve list of systems. Use search and select query parameters to limit results.
     * Retrieve systems
     */
    SystemsApi.prototype.getSystemsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.search !== undefined) {
                            queryParameters['search'] = requestParameters.search;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.orderBy !== undefined) {
                            queryParameters['orderBy'] = requestParameters.orderBy;
                        }
                        if (requestParameters.skip !== undefined) {
                            queryParameters['skip'] = requestParameters.skip;
                        }
                        if (requestParameters.startAfter !== undefined) {
                            queryParameters['startAfter'] = requestParameters.startAfter;
                        }
                        if (requestParameters.computeTotal !== undefined) {
                            queryParameters['computeTotal'] = requestParameters.computeTotal;
                        }
                        if (requestParameters.select !== undefined) {
                            queryParameters['select'] = requestParameters.select;
                        }
                        if (requestParameters.showDeleted !== undefined) {
                            queryParameters['showDeleted'] = requestParameters.showDeleted;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/systems",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespSystemsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieve list of systems. Use search and select query parameters to limit results.
     * Retrieve systems
     */
    SystemsApi.prototype.getSystems = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSystemsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Check if a system is currently enabled, i.e. available for use.
     * Check if system is currently enabled
     */
    SystemsApi.prototype.isEnabledRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.systemId === null || requestParameters.systemId === undefined) {
                            throw new runtime.RequiredError('systemId', 'Required parameter requestParameters.systemId was null or undefined when calling isEnabled.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/systems/{systemId}/isEnabled".replace("{" + "systemId" + "}", encodeURIComponent(String(requestParameters.systemId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespBooleanFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Check if a system is currently enabled, i.e. available for use.
     * Check if system is currently enabled
     */
    SystemsApi.prototype.isEnabled = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isEnabledRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * *WARNING Capability constraint matching is not yet supported.* Retrieve details for systems. Use request body to specify constraint conditions as an SQL-like WHERE clause.
     * Retrieve systems satisfying specified constraint conditions (WARNING - not yet supported)
     */
    SystemsApi.prototype.matchConstraintsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqMatchConstraints === null || requestParameters.reqMatchConstraints === undefined) {
                            throw new runtime.RequiredError('reqMatchConstraints', 'Required parameter requestParameters.reqMatchConstraints was null or undefined when calling matchConstraints.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/systems/match/constraints",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ReqMatchConstraintsToJSON(requestParameters.reqMatchConstraints),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespSystemsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * *WARNING Capability constraint matching is not yet supported.* Retrieve details for systems. Use request body to specify constraint conditions as an SQL-like WHERE clause.
     * Retrieve systems satisfying specified constraint conditions (WARNING - not yet supported)
     */
    SystemsApi.prototype.matchConstraints = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.matchConstraintsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update selected attributes of a system. Request body may only contain updatable attributes. System must exist.  Attributes that may not be updated via PATCH are    - id   - systemType   - owner   - enabled   - bucketName   - rootDir   - isDtn   - canExec  Note that the attributes owner and enabled may be modified using other endpoints.
     * Update selected attributes of a system
     */
    SystemsApi.prototype.patchSystemRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.systemId === null || requestParameters.systemId === undefined) {
                            throw new runtime.RequiredError('systemId', 'Required parameter requestParameters.systemId was null or undefined when calling patchSystem.');
                        }
                        if (requestParameters.reqPatchSystem === null || requestParameters.reqPatchSystem === undefined) {
                            throw new runtime.RequiredError('reqPatchSystem', 'Required parameter requestParameters.reqPatchSystem was null or undefined when calling patchSystem.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/systems/{systemId}".replace("{" + "systemId" + "}", encodeURIComponent(String(requestParameters.systemId))),
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ReqPatchSystemToJSON(requestParameters.reqPatchSystem),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespResourceUrlFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update selected attributes of a system. Request body may only contain updatable attributes. System must exist.  Attributes that may not be updated via PATCH are    - id   - systemType   - owner   - enabled   - bucketName   - rootDir   - isDtn   - canExec  Note that the attributes owner and enabled may be modified using other endpoints.
     * Update selected attributes of a system
     */
    SystemsApi.prototype.patchSystem = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchSystemRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update all updatable attributes of a system using a request body identical to POST. System must exist.  By default any credentials provided for LINUX type systems are verified. Use query parameter skipCredentialCheck=true to bypass initial verification of credentials.  Note that certain attributes (such as tenant) are allowed but ignored so that the JSON result returned by a GET may be modified and used when making a PUT request to update a system.  The attributes that are allowed but ignored for both PUT and POST are    - tenant   - uuid   - deleted   - created   - updated  In addition for a PUT operation the following non-updatable attributes are allowed but ignored    - id   - systemType   - owner   - enabled   - bucketName   - rootDir   - isDtn   - canExec  Note that the attributes owner and enabled may be modified using other endpoints.
     * Update all updatable attributes of a system
     */
    SystemsApi.prototype.putSystemRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.systemId === null || requestParameters.systemId === undefined) {
                            throw new runtime.RequiredError('systemId', 'Required parameter requestParameters.systemId was null or undefined when calling putSystem.');
                        }
                        if (requestParameters.reqPutSystem === null || requestParameters.reqPutSystem === undefined) {
                            throw new runtime.RequiredError('reqPutSystem', 'Required parameter requestParameters.reqPutSystem was null or undefined when calling putSystem.');
                        }
                        queryParameters = {};
                        if (requestParameters.skipCredentialCheck !== undefined) {
                            queryParameters['skipCredentialCheck'] = requestParameters.skipCredentialCheck;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/systems/{systemId}".replace("{" + "systemId" + "}", encodeURIComponent(String(requestParameters.systemId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ReqPutSystemToJSON(requestParameters.reqPutSystem),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespResourceUrlFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update all updatable attributes of a system using a request body identical to POST. System must exist.  By default any credentials provided for LINUX type systems are verified. Use query parameter skipCredentialCheck=true to bypass initial verification of credentials.  Note that certain attributes (such as tenant) are allowed but ignored so that the JSON result returned by a GET may be modified and used when making a PUT request to update a system.  The attributes that are allowed but ignored for both PUT and POST are    - tenant   - uuid   - deleted   - created   - updated  In addition for a PUT operation the following non-updatable attributes are allowed but ignored    - id   - systemType   - owner   - enabled   - bucketName   - rootDir   - isDtn   - canExec  Note that the attributes owner and enabled may be modified using other endpoints.
     * Update all updatable attributes of a system
     */
    SystemsApi.prototype.putSystem = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.putSystemRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve details for systems. Use query parameters to specify search conditions. For example owner.eq=jdoe&port.gt=1024
     * Retrieve list of systems matching search conditions specified as query parameters
     */
    SystemsApi.prototype.searchSystemsQueryParametersRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.freeFormParameterName !== undefined) {
                            queryParameters['freeFormParameterName'] = requestParameters.freeFormParameterName;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.orderBy !== undefined) {
                            queryParameters['orderBy'] = requestParameters.orderBy;
                        }
                        if (requestParameters.skip !== undefined) {
                            queryParameters['skip'] = requestParameters.skip;
                        }
                        if (requestParameters.startAfter !== undefined) {
                            queryParameters['startAfter'] = requestParameters.startAfter;
                        }
                        if (requestParameters.computeTotal !== undefined) {
                            queryParameters['computeTotal'] = requestParameters.computeTotal;
                        }
                        if (requestParameters.select !== undefined) {
                            queryParameters['select'] = requestParameters.select;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/systems/search",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespSystemsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieve details for systems. Use query parameters to specify search conditions. For example owner.eq=jdoe&port.gt=1024
     * Retrieve list of systems matching search conditions specified as query parameters
     */
    SystemsApi.prototype.searchSystemsQueryParameters = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.searchSystemsQueryParametersRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve details for systems. Use request body to specify SQL-like search conditions.
     * Retrieve list of systems matching search conditions
     */
    SystemsApi.prototype.searchSystemsRequestBodyRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqSearchSystems === null || requestParameters.reqSearchSystems === undefined) {
                            throw new runtime.RequiredError('reqSearchSystems', 'Required parameter requestParameters.reqSearchSystems was null or undefined when calling searchSystemsRequestBody.');
                        }
                        queryParameters = {};
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.orderBy !== undefined) {
                            queryParameters['orderBy'] = requestParameters.orderBy;
                        }
                        if (requestParameters.skip !== undefined) {
                            queryParameters['skip'] = requestParameters.skip;
                        }
                        if (requestParameters.startAfter !== undefined) {
                            queryParameters['startAfter'] = requestParameters.startAfter;
                        }
                        if (requestParameters.computeTotal !== undefined) {
                            queryParameters['computeTotal'] = requestParameters.computeTotal;
                        }
                        if (requestParameters.select !== undefined) {
                            queryParameters['select'] = requestParameters.select;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/systems/search",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ReqSearchSystemsToJSON(requestParameters.reqSearchSystems),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespSystemsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieve details for systems. Use request body to specify SQL-like search conditions.
     * Retrieve list of systems matching search conditions
     */
    SystemsApi.prototype.searchSystemsRequestBody = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.searchSystemsRequestBodyRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Mark a system as not deleted. System will appear in queries.
     * Mark a system as not deleted
     */
    SystemsApi.prototype.undeleteSystemRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.systemId === null || requestParameters.systemId === undefined) {
                            throw new runtime.RequiredError('systemId', 'Required parameter requestParameters.systemId was null or undefined when calling undeleteSystem.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/systems/{systemId}/undelete".replace("{" + "systemId" + "}", encodeURIComponent(String(requestParameters.systemId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespChangeCountFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Mark a system as not deleted. System will appear in queries.
     * Mark a system as not deleted
     */
    SystemsApi.prototype.undeleteSystem = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.undeleteSystemRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return SystemsApi;
}(runtime.BaseAPI));
exports.SystemsApi = SystemsApi;
